console.log(
  "There are no analytics or tracking scripts on this page. If you notice anything that looks like tracking, please send any information about it to me at contact@usman.xyz, thanks! https://blog.usmanity.com/killing-analytics-on-my-personal-sites/"
);
